<template>
  <a-drawer
    ref="productComparison"
    title="配方 VS 产品"
    placement="right"
    :visible="hidden"
    @close="onClose"
    width="900"
    destroyOnClose
  >
    <a-tabs default-active-key="1">
      <a-tab-pane tab="原料" key="1">
        <product-drawer :hidden="hidden" :tabKey="tabKey" :y="curHeight" :diff="diff" />
      </a-tab-pane>
      <a-tab-pane tab="营养需要量" key="2">
        <NutirtionDrawer :hidden="hidden" :tabKey="tabKey" :y="curHeight" :diff="diff" />
      </a-tab-pane>
      <a-checkbox v-model="diff" slot="tabBarExtraContent" class="icon-bar">
        仅展示有差异项
      </a-checkbox>
    </a-tabs>
  </a-drawer>
</template>
<script>
import ProductDrawer from './ProductDrawer.vue';
import NutirtionDrawer from './NutirtionDrawer.vue'
export default {
  components:{ProductDrawer,NutirtionDrawer},
  props: ['hidden'],
  data(){
    return {
      tabKey: '1',
      curHeight: 500,
      diff:false
    }
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.curHeight = h - (height || 0) - 180; 
  },
  methods: {
    onClose(){
      this.$emit('cancel');
    }
  }
}
</script>
